export const Spinkit = {
    skLine: 'sk-line-material'
};

